// @flow
import React from 'react';
import MasonryPerfTimingLegacy from 'app/common/react/components/Masonry/MasonryPerfTimingLegacy';
import { useExperiment } from 'app/common/react/components/experiments/useExperiment';
import MasonryPerfTimingExperimental, {
  type Props,
} from 'app/common/react/components/Masonry/MasonryPerfTimingExperimental';

export default function MasonryPerfTiming(props: Props) {
  const { anyEnabled: newMasonryPerfTiming } = useExperiment('web_masonry_perf_timing_refactor');
  const Comp = newMasonryPerfTiming ? MasonryPerfTimingExperimental : MasonryPerfTimingLegacy;
  return <Comp {...props} />;
}
